import React, { useState, useEffect } from 'react';
import ProgramBasicsEdit from "../components/Forms/ProgramBasicEdit";
import {Tabs, TabsHeader, TabsBody, Tab} from "@material-tailwind/react";
import Session from '../components/Forms/ProgramSession';
import Question from '../components/Forms/ProgramQuestion';
import { useParams } from 'react-router-dom';
import CounsellingSessions from '../components/Forms/ProgramCounsellingSlots';
import apiClient from '../api/apiClient';
import { useTranslation } from 'react-i18next';

export default function Program() {
    const { t } = useTranslation();
    const { id:programId } = useParams()  
    const [activeTab, setActiveTab] = useState<number>(0);
    const [hasCounselling, setHasCounselling] = useState<boolean>(true);

    useEffect(() => {
      const fetchProgramHasCounselling = async () => {
        try {
          if (!programId) return;
          const response = await apiClient.get(`/api/v1/programs/${programId}`);
          setHasCounselling(response.data.data.hasCounselling !== false);
        } catch (error) {
          console.error("Error fetching program details:", error);
        }
      };
      fetchProgramHasCounselling();
    }, [programId]);

    const handleTabChange = (index: number) => {
      setActiveTab(index);
    };
    const chnageTab  = (index: number) => {
        setActiveTab(index);
      };
    const updateHasCounselling = (value: boolean) => {
        setHasCounselling(value);
      };
return (
        <>
         <h2 className="py-1 pb-4 text-2xl font-gilroy font-semibold text-[#263238]">{t("adminPrograms.updateProgramTitle", "Update Program")}</h2>
         <div className="bg-white h-[calc(100vh-190px)] overflow-y-hidden rounded-md py-2">
          
            <Tabs>
                <TabsHeader className='border-b-2  rounded-none mx-6 ' >
                    <Tab
                    key="Basic"
                    value="Basic"
                    onClick={() => handleTabChange(0)}
                    className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 border-[#ECEFF1] ${activeTab === 0 ? 'active' : ''}  `}                      
                    >
                    {t("adminPrograms.tabs.basic", "Basic")}
                    </Tab>
                    <Tab
                    key="Sessions"
                    value="Sessions"
                    onClick={() => handleTabChange(1)}
                    className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 border-[#ECEFF1]  ${activeTab === 1 ? 'active' : ''}  `}
                    >
                    {t("adminPrograms.tabs.sessions", "Sessions")}
                    </Tab>
                    <Tab
                    key="Question"
                    value="Question"
                    onClick={() => handleTabChange(2)}
                    className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 border-[#ECEFF1]  ${activeTab === 2 ? 'active' : ''}  `}
                    >
                    {t("adminPrograms.tabs.questions", "Questions")}
                    </Tab>
                    <Tab    
                    key="Counselling"
                    value="Counselling"
                    onClick={() => handleTabChange(3)}
                    className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 border-[#ECEFF1]  ${activeTab === 3 ? 'active' : ''} ${!hasCounselling ? 'hidden' : ''}`}
                    >
                    {t("adminPrograms.tabs.counselling", "1-1 Counselling")}
                    </Tab>
                </TabsHeader>

                <TabsBody>
                    <div className={activeTab === 0 ? 'tab-panel active' : 'tab-panel'}>
                    {activeTab === 0 && <ProgramBasicsEdit chnageTab={()=>chnageTab(1)} updateHasCounselling={updateHasCounselling} />}
                    </div>
                    <div className={activeTab === 1 ? 'tab-panel active' : 'tab-panel'}>
                    {activeTab === 1 && <Session programId={programId}/> }
                    </div>
                    <div className={activeTab === 2 ? 'tab-panel active' : 'tab-panel'}>
                    {activeTab === 2 && <Question programId={programId}/> }
                    </div>
                    <div className={activeTab === 3 ? 'tab-panel active' : 'tab-panel'}>
                    {activeTab === 3 && <CounsellingSessions programId={programId}/> }
                    </div>
                </TabsBody>
            </Tabs>
        </div>
        </>
    )
}
    